(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MeetParkerCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["MeetParkerCalculator"] = factory();
	else
		root["MeetParkerCalculator"] = factory();
})(self, () => {
return 